module.exports = __webpack_public_path__ + "static/media/check-white.f50a2ded.svg";